module.exports = __webpack_public_path__ + "static/fonts/ionicons.99ac330.woff";


//////////////////
// WEBPACK FOOTER
// ./~/view-design/src/styles/common/iconfont/fonts/ionicons.woff?v=3.0.0
// module id = 570
// module chunks = 8